export const RELEASE_LINE = {
  angular: '4.4.x',
  packageVersion: '4.0.0',
  coreVersion: '0.1.1',
  runtimeTarget: 'Angular 4 + Angular CLI',
  docsPath: '/angular-4/'
};



// WEBPACK FOOTER //
// /tmp/stackline-angular-loading-docs-4-fU6jD5/src/app/data/release-line.ts